import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f142be86"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f142be86')) {
      api.createRecord('f142be86', component.options)
    } else {
      api.reload('f142be86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f142be86", function () {
      api.rerender('f142be86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LangSelect/index.vue"
export default component.exports